import React from "react";

interface Props {
  className?: string;
}

const LinkIcon: React.FC<Props> = ({ className }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M11.4672 6.69381L13.3234 4.83756C14.1094 4.12124 15.1411 3.73529 16.2042 3.7599C17.2672 3.78451 18.28 4.2178 19.0319 4.96972C19.7838 5.72164 20.2171 6.73438 20.2417 7.79748C20.2663 8.86057 19.8804 9.89227 19.1641 10.6782L16.5109 13.3219C16.1286 13.7057 15.6742 14.0103 15.1738 14.2181C14.6735 14.4259 14.1371 14.5328 13.5953 14.5328C13.0535 14.5328 12.5171 14.4259 12.0168 14.2181C11.5164 14.0103 11.0621 13.7057 10.6797 13.3219"
          stroke="#313131"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5335 17.3063L10.6772 19.1625C9.8913 19.8789 8.85959 20.2648 7.7965 20.2402C6.7334 20.2156 5.72067 19.7823 4.96874 19.0304C4.21682 18.2785 3.78353 17.2657 3.75892 16.2026C3.73431 15.1395 4.12027 14.1078 4.83659 13.3219L7.48971 10.6782C7.87208 10.2944 8.32647 9.98984 8.8268 9.78204C9.32713 9.57425 9.86357 9.46729 10.4053 9.46729C10.9471 9.46729 11.4835 9.57425 11.9839 9.78204C12.4842 9.98984 12.9386 10.2944 13.321 10.6782"
          stroke="#313131"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default LinkIcon;
